import { AppId } from '@inno-tools/container-bridge'
import calendarVideo from 'public/discover-apps/calendar.mp4'
import filesVideo from 'public/discover-apps/files.mp4'
import hrVideo from 'public/discover-apps/hr.mp4'
import taskManagementVideo from 'public/discover-apps/task-management.mp4'
import timeTrackingVideo from 'public/discover-apps/time-tracking.mp4'

// Type for translation keys under discover_apps namespace (with keyPrefix: 'discover_apps')
// These are the keys relative to the discover_apps namespace
type DiscoverAppsTranslationKey =
  | 'title'
  | 'buttons.tour'
  | 'buttons.tell_me_more'
  | 'cards.time_tracking.title'
  | 'cards.time_tracking.feature_name'
  | 'cards.time_tracking.heading'
  | 'cards.time_tracking.description'
  | 'cards.task_management.title'
  | 'cards.task_management.feature_name'
  | 'cards.task_management.heading'
  | 'cards.task_management.description'
  | 'cards.files.title'
  | 'cards.files.feature_name'
  | 'cards.files.heading'
  | 'cards.files.description'
  | 'cards.calendar.title'
  | 'cards.calendar.feature_name'
  | 'cards.calendar.heading'
  | 'cards.calendar.description'
  | 'cards.hr.title'
  | 'cards.hr.feature_name'
  | 'cards.hr.heading'
  | 'cards.hr.description'

export interface FeatureCardData {
  id: string
  titleKey: DiscoverAppsTranslationKey
  featureNameKey: DiscoverAppsTranslationKey
  headingKey: DiscoverAppsTranslationKey
  descriptionKey: DiscoverAppsTranslationKey
  videoPath: string
  appId: AppId
  row: 1 | 2
}

export const FEATURE_CARDS: FeatureCardData[] = [
  {
    id: 'time-tracking',
    titleKey: 'cards.time_tracking.title',
    featureNameKey: 'cards.time_tracking.feature_name',
    headingKey: 'cards.time_tracking.heading',
    descriptionKey: 'cards.time_tracking.description',
    videoPath: timeTrackingVideo,
    appId: AppId.TIMETRACKING,
    row: 1
  },
  {
    id: 'task-management',
    titleKey: 'cards.task_management.title',
    featureNameKey: 'cards.task_management.feature_name',
    headingKey: 'cards.task_management.heading',
    descriptionKey: 'cards.task_management.description',
    videoPath: taskManagementVideo,
    appId: AppId.TASK_MANAGEMENT,
    row: 1
  },
  {
    id: 'files',
    titleKey: 'cards.files.title',
    featureNameKey: 'cards.files.feature_name',
    headingKey: 'cards.files.heading',
    descriptionKey: 'cards.files.description',
    videoPath: filesVideo,
    appId: AppId.CLUSTER_FILES,
    row: 2
  },
  {
    id: 'calendar',
    titleKey: 'cards.calendar.title',
    featureNameKey: 'cards.calendar.feature_name',
    headingKey: 'cards.calendar.heading',
    descriptionKey: 'cards.calendar.description',
    videoPath: calendarVideo,
    appId: AppId.CALENDAR,
    row: 2
  },
  {
    id: 'hr',
    titleKey: 'cards.hr.title',
    featureNameKey: 'cards.hr.feature_name',
    headingKey: 'cards.hr.heading',
    descriptionKey: 'cards.hr.description',
    videoPath: hrVideo,
    appId: AppId.HR,
    row: 2
  }
]

export const MODAL_MAX_WIDTH = '110rem'
export const MODAL_MAX_HEIGHT = 860
export const MODAL_Z_INDEX = 100
